import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Retry only what a retry can fix.
			retry: (count, err) => err instanceof ApiError && err.transient && count < 3,
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
			staleTime: 30_000,
			refetchOnWindowFocus: false,
		},
		mutations: { retry: false },
	},
});
